{
    "comment_slider.response": "Argument",
    "comment_slider.responses": "Argumente",
    "editorial_question.lets_talk": "Schlagen Sie eine Lösung vor",
    "editorial_question.share_thoughts": "Teilen Sie Ihren Lösungsvorschlag",
    "login.continue_with": "Zum SRG-Login",
    "question.input_placeholder": "Ihre Lösung:",
    "upvote.count": "{count}x unterstützt"
}
